"use client"

import { CloseOutlined, InfoCircleTwoTone, InfoOutlined, SyncOutlined } from "@ant-design/icons";

const InfoBlock = ({
    text,
    onClose,
    loading = false,
    danger= false,
}: {
    text: string;
    onClose?: () => void;
    loading?: boolean;
    danger?: boolean;
}) => {
    return (
        <div className="flex border rounded-lg items-center px-2 space-x-4" style={{}}>
            {loading ? <SyncOutlined spin /> : danger ? <InfoCircleTwoTone twoToneColor="#eb2f96" /> : <InfoOutlined />}
            <div className="text-sm">{text}</div>
            {onClose && (
                <button className="hover:text-danger" style={{}} onClick={onClose}>
                    <CloseOutlined />
                </button>
            )}
        </div>
    );
};

export default InfoBlock;
